const DEFAULT_BASE = "https://api.growthstationco.com";
export const DEFAULT_AVATAR =
  "https://ui-avatars.com/api/?name=User&background=random&size=128";

/**
 * Resolve image src for:
 * - absolute URLs: http/https
 * - data URLs: data:
 * - blob URLs: blob:
 * - absolute paths: /uploads/...
 * - relative paths: uploads/...
 * - default avatar: /default-avatar.png
 */
export function resolveImageUrl(path, base = DEFAULT_BASE) {
  if (!path) return DEFAULT_AVATAR;
  const s = String(path);
  if (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("data:") ||
    s.startsWith("blob:")
  ) {
    return s;
  }
  if (s === "/default-avatar.png" || s === "default-avatar.png") {
    return DEFAULT_AVATAR;
  }
  if (s.startsWith("/")) return `${base}${s}`;
  return `${base}/${s}`;
}

/**
 * Extract the avatar URL from a user object.
 * The server stores the photo in different fields depending on the endpoint:
 *   - JWT token payload  → user.photo
 *   - /employee/profile  → user.profilePicture.url  or  user.avatar
 *   - after upload       → res.photo  or  res.profilePicture.url  or  res.avatar
 * This helper checks all known locations so nothing is missed.
 */

export function getUserAvatarUrl(user) {
  if (!user) return null;
  const raw =
    user?.photo ||
    user?.avatar ||
    user?.profilePicture?.url ||
    user?.data?.photo ||
    user?.data?.avatar ||
    user?.data?.profilePicture?.url ||
    null;
  return raw ? resolveImageUrl(raw) : null;
}